import {
  type SbbTransportApiContext,
  getAirportBookingsPath,
  getAirportSbbTransportsBasePath
} from "../../../../common/utils/transport/sbbTransportApiContext";

export type SbbResolvedApiPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      infoPath: string;
      stationsSearchUrl: (apiUrl: string, query: string) => string;
      prebookPath: string;
      bookingsPath: string;
    };

export function resolveSbbApiPaths(
  isZurichCard: boolean,
  transportContext: SbbTransportApiContext
): SbbResolvedApiPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }
  if (isZurichCard) {
    return {
      kind: "ok",
      infoPath: "transport/zurich_card",
      stationsSearchUrl: (apiUrl, query) => `${apiUrl}/transport/sbb/stations?stationName=${encodeURIComponent(query)}`,
      prebookPath: "transport/zurich_card/prebook",
      bookingsPath: "bookings"
    };
  }
  if (transportContext.mode === "airline") {
    const base = getAirportSbbTransportsBasePath(transportContext.iataCode);
    return {
      kind: "ok",
      infoPath: base,
      stationsSearchUrl: (apiUrl, query) => `${apiUrl}/${base}/stations?stationName=${encodeURIComponent(query)}`,
      prebookPath: `${base}/prebook`,
      bookingsPath: getAirportBookingsPath(transportContext.iataCode)
    };
  }
  return {
    kind: "ok",
    infoPath: "transport/sbb",
    stationsSearchUrl: (apiUrl, query) => `${apiUrl}/transport/sbb/stations?stationName=${encodeURIComponent(query)}`,
    prebookPath: "transport/sbb/prebook",
    bookingsPath: "bookings"
  };
}
